import careersRoutes from "./src/config/careersRoutes.json";
import { isCareersOrJobsPath } from "./src/utils/careersRoutes";

export const onRouteUpdate = ({ location }) => {
  if (careersRoutes.enabled || typeof window === "undefined") return;

  if (isCareersOrJobsPath(location.pathname)) {
    window.location.replace("/404");
  }
};

export const shouldUpdateScroll = ({ prevLocation, location }) => {
  if (
    !careersRoutes.enabled &&
    prevLocation &&
    isCareersOrJobsPath(location.pathname)
  ) {
    return false;
  }
  return true;
};
